let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("5Yiax")]).then(() => parcelRequire('7G6RL'));